import { createFileRoute } from '@tanstack/react-router';

import { CallbackHandler } from '../features/auth/callback.js';

export const Route = createFileRoute('/auth/callback')({
  component: CallbackHandler,
});
